import { Box, Stack } from '@mui/material'
import { IProductWarrantyClaimDetails, MediaCategories } from '@cbgms/api'
import Lightbox from '@cbgms/components/lightbox/Lightbox'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import '../../../assets/styles/imageViewDialog.less'
import { useBase64BlobUrl } from 'app-support/media/hooks/use-build-base64-blob-url'
import { adhocAttachmentWholesalerUUID } from '../utils'
import { SupportMediaParams } from 'app-support/media/state/request'
import { getPrivateMediaItem } from 'app-support/media/state/actions'

interface ImageViewDialogProps {
  selectedFile: IProductWarrantyClaimDetails['AttachmentsS3'][number]
  allImages: IProductWarrantyClaimDetails['AttachmentsS3']
  companyUUID: string
  onCancel: () => void
}

export function ImageViewDialog(props: ImageViewDialogProps) {
  const buildBlobURL = useBase64BlobUrl()
  const dispatch = useDispatch()
  const [allAttachments, setAllAttachments] = useState(
    props.allImages.map(att => {
      return {
        ...att,
        Url: ''
      }
    })
  )

  const buildMediaItemURL = async (fileName: string) => {
    const SupportMediaParams: SupportMediaParams = {
      category: MediaCategories.AdhocAttachments,
      companyUUID: props.companyUUID,
      subCategory: adhocAttachmentWholesalerUUID,
      fileName
    }
    const { Data } = await dispatch(getPrivateMediaItem(SupportMediaParams))
    return buildBlobURL(Data.Data, Data.ContentType)
  }

  const currentFile = {
    selectedFile: props.selectedFile,
    url: buildMediaItemURL(props.selectedFile.Name)
  }
  const [imageIndex, setImageIndex] = useState(props.allImages.findIndex(att => att.Key === currentFile.selectedFile.Key))

  useEffect(() => {
    const fetchImageUrl = async () => {
      const images = await Promise.all(
        allAttachments.map(async att => {
          return {
            ...att,
            Url: await buildMediaItemURL(att.Name)
          }
        })
      )
      setAllAttachments(images)
    }
    fetchImageUrl()
  }, [])

  const getLightBoxCaption = () => {
    return (
      <Stack direction='row' alignItems='center'>
        <Box fontSize={24} fontWeight='600'>
          {imageIndex + 1}
        </Box>
        <Box fontSize={18}>{`/${allAttachments.length}`}</Box>
      </Stack>
    )
  }

  return (
    <Box data-testid='image-view-dialog-image'>
      <Lightbox
        mainSrc={allAttachments[imageIndex].Url}
        nextSrc={allAttachments.length >= 2 ? allAttachments[(imageIndex + 1) % allAttachments.length].Url : undefined}
        prevSrc={
          allAttachments.length >= 2 ? allAttachments[(imageIndex + allAttachments.length - 1) % allAttachments.length].Url : undefined
        }
        onCloseRequest={props.onCancel}
        onMovePrevRequest={() => setImageIndex((imageIndex + allAttachments.length - 1) % allAttachments.length)}
        onMoveNextRequest={() => setImageIndex((imageIndex + 1) % allAttachments.length)}
        data-testid='product-warranty-claims-lightbox'
        imageTitle={allAttachments[imageIndex].Name}
        imageCaption={getLightBoxCaption()}
      />
    </Box>
  )
}
